import styled, { css } from "styled-components";
import { CSSProp } from "styled-components";

export interface RowProps extends React.HTMLAttributes<HTMLDivElement> {
    gap?: number;
    flex?: number | string;
    alignItems?: "flex-start" | "flex-end" | "center" | "stretch" | "baseline" | "end";
    justifyContent?: "flex-start" | "flex-end" | "center" | "space-between" | "space-around" | "space-evenly" | "start" | "end";
    wrap?: boolean;
    css?: CSSProp;
    breakpoint?: {
        width?: string | number;
        gap?: number;
        alignItems?: string;
        justifyContent?: string;
        reverse?: boolean;
    };
}

const RowRoot = styled.div<RowProps>`
    display: flex;
    flex-direction: row;
    ${({ gap }) =>
        gap !== undefined &&
        css`
            gap: ${gap}px;
        `}
    ${({ flex }) =>
        flex !== undefined &&
        css`
            flex: ${typeof flex === "number" ? flex : flex};
        `}
    ${({ alignItems }) =>
        alignItems &&
        css`
            align-items: ${alignItems};
        `}
    ${({ justifyContent }) =>
        justifyContent &&
        css`
            justify-content: ${justifyContent};
        `}
    ${({ wrap }) =>
        wrap &&
        css`
            flex-wrap: wrap;
        `}
    ${({ breakpoint, theme }) =>
        breakpoint &&
        css`
            @media (max-width: ${typeof breakpoint.width === "number" ? `${breakpoint.width}px` : theme.breakpoints.down(breakpoint.width || "mobile").replace("@media (max-width: ", "").replace(")", "")}) {
                ${breakpoint.gap !== undefined &&
                css`
                    gap: ${breakpoint.gap}px;
                `}
                ${breakpoint.alignItems &&
                css`
                    align-items: ${breakpoint.alignItems};
                `}
                ${breakpoint.justifyContent &&
                css`
                    justify-content: ${breakpoint.justifyContent};
                `}
                ${breakpoint.reverse !== undefined &&
                css`
                    flex-direction: ${breakpoint.reverse ? "row-reverse" : "row"};
                `}
            }
        `}
`;

// eslint-disable-next-line react/prop-types
const Row: React.FC<RowProps> = ({ children, ...props }) => {
    return <RowRoot {...props}>{children}</RowRoot>;
};

export default Row;


